import { TUTMParams } from 'src/stores/utm/atoms';
import {
  PaymentsReservation,
  PaymentsReserveResponse,
  PgPaymentMethodType,
  PurchasableProduct,
} from 'src/types/Payments';
import { client } from 'src/utils/api';
import { createApiCall } from 'src/utils/api';
import { getProductCurrency, getProductPrice } from 'src/utils/payments';

import { DeletePaymentMethodRequest } from './types';

export enum PaymentApiList {
  CompletePayment = '/api/payments/complete',
}

export const reservePaymentAPI = (
  product: PurchasableProduct,
  paymentMethod: PgPaymentMethodType,
  utmParameter: TUTMParams
): Promise<PaymentsReservation> =>
  client
    .post<PaymentsReserveResponse>('/api/payments/reserve', {
      paymentMethod,
      productId: product.productId,
      productName: product.productName,
      amount: getProductPrice(product).toString(),
      currency: getProductCurrency(product),
      utmParameter,
    })
    .then((res) => ({ ...res.data, paymentMethod }) as PaymentsReservation);

export const deletePaymentMethodAPI = createApiCall<DeletePaymentMethodRequest>(
  'delete',
  '/api/payments/stored-payment-methods'
);
